import React, { Component } from 'react'
import { apiProcess } from '../../api/api.js'
import { withRouter } from 'react-router-dom'
import QueryString from 'query-string'
import isEqual from 'lodash/isEqual'
import {
  LATITUDE_SHORT_NAME,
  LONGITUDE_SHORT_NAME,
  LOCATION_SHORT_NAME,
} from '../filters/location/locationFiltersConfig'
import {
  addToUrlPush,
  formatFilterURLValues,
  formatForAPI,
  removeDefaults,
} from '../filters/filterUtil.js'
import { mapboxDiscoverLocationFilters } from './mapboxDiscoverLocation'
import { trackSearchAPIRan } from '../../elements/tracking/searchTracking.js'
import { PAGE_COUNT_FILTER_SHORT_NAME } from '../filters/pagination/pageCountFilterConfig.js'

class CallSearch extends Component {
  constructor(props) {
    super(props)
    this.state = {
      searchLoading: false,
      mapboxSearchLoading: false,
      searchError: false,
      mapboxSearchError: false,
      hasSearchData: false,
      hasMapboxSearchData: false,
      allCoordinates: [],
      searchData: [],
      groupedMarkers: [],
      initialURLParams: {},
      initialLoading: true,
      searchCount: 0,
      advertisement: null,
    }
  }

  componentDidMount() {
    if (this.props.parseURLOnMount) {
      this.setInitialParams()
      //this.runSearch(this.state.initialURLParams)
    } else {
      this.runMapBoxSearch(this.props.searchFilters, 'run mapbox search component did mount')
      let urlParams = this.props.searchFilters
      urlParams[PAGE_COUNT_FILTER_SHORT_NAME] = 10
      this.setState({ initialURLParams: urlParams })
      this.runSearch(urlParams, 'runsearch component did mount')
    }

    this.fetchAdvertisement()
  }

  fetchAdvertisement = () => {
    let apiURL = 'advertisement/for_search'
    apiProcess(apiURL, null, 'search-advertisement', 'advertisement call from search')
      .then(
        function (responseData) {
          if (responseData.advertisement) {
            this.setState({
              advertisement: responseData.advertisement
            })
          }
        }.bind(this)
      )
      .catch(
        function (responseData) {
          this.setState({
            advertisement: null
          })
          console.log("Failed to fetch advertisemnt for /search")
        }.bind(this)
      )
  }

  setInitialParams = () => {
    let urlValues = QueryString.parse(this.props.location.search, {
      arrayFormat: 'comma',
      parseNumbers: true,
      parseBooleans: true,
    })

    let hasGooseEgg = false

    if (urlValues.goose_egg) {
      hasGooseEgg = true
      delete urlValues.goose_egg
    }
    let cleanURLParams = formatFilterURLValues(urlValues) //this skips location, latitude, and longitude

    mapboxDiscoverLocationFilters({
      values: cleanURLParams,
      onSuccess: (locationValues) =>
        this.discoverLocationSuccess(cleanURLParams, locationValues, hasGooseEgg),
    })

    //if discoverLocationFilters ever stops working, you can just pass the url value directory and assume those values are good.
    //this.discoverLocationSuccess(cleanURLParams, {
    //latitude: urlValues.latitude,
    //longitude: urlValues.longitude,
    // location: urlValues.location
    //})
  }

  componentDidUpdate(prevProps, props) {
    let newURLValues = QueryString.parse(this.props.location.search, {
      arrayFormat: 'comma',
      parseNumbers: true,
      parseBooleans: true,
    })
    let prevURLValues = QueryString.parse(prevProps.location.search, {
      arrayFormat: 'comma',
      parseNumbers: true,
      parseBooleans: true,
    })
    if (!isEqual(newURLValues, prevURLValues)) {
      this.setInitialParams()
    }
  }

  discoverLocationSuccess = async (urlValues, locationValues, hasGooseEgg) => {
    let initialValues = JSON.parse(JSON.stringify(urlValues))

    //here we set the location values in the urls values
    initialValues[LOCATION_SHORT_NAME] = locationValues[LOCATION_SHORT_NAME]
    initialValues[LATITUDE_SHORT_NAME] = locationValues[LATITUDE_SHORT_NAME]
    initialValues[LONGITUDE_SHORT_NAME] = locationValues[LONGITUDE_SHORT_NAME]
    this.setState({
      initialURLParams: initialValues,
    })

    if (this.props.updateURLOnLocationDiscovery) {
      let valuesToAddToURL = [
        {
          key: LOCATION_SHORT_NAME,
          value: locationValues[LOCATION_SHORT_NAME],
        },
        {
          key: LATITUDE_SHORT_NAME,
          value: locationValues[LATITUDE_SHORT_NAME],
        },
        {
          key: LONGITUDE_SHORT_NAME,
          value: locationValues[LONGITUDE_SHORT_NAME],
        },
      ]
      let newQueryString = addToUrlPush(
        valuesToAddToURL,
        this.props.location.search
      )

      this.props.history.push('?' + newQueryString.string)
    }

    this.runMapBoxSearch(initialValues, 'mapbox call back')
    // page_count should be applied  only search not for MapBox search
    initialValues[PAGE_COUNT_FILTER_SHORT_NAME] = 10
    this.runSearch(initialValues, 'discover filters call back', true, hasGooseEgg)
    this.setState({
      initialURLParams: initialValues,
    })
    return initialValues
  }

  runMapBoxSearch = (passedInValues, searchCallDesc) => {
    if (passedInValues) {
      if (passedInValues.latitude == null || passedInValues.longitude == null) {
        if (this.props.isGeolocationEnabled && this.state.searchCount === 0) {
          return false
        }
      }
    }

    this.setState({
      mapboxSearchLoading: true,
      mapboxSearchError: false
    })

    let mapboxSearchData = {}

    if (passedInValues) {
      mapboxSearchData = JSON.parse(JSON.stringify(passedInValues))
    } else if (this.props.searchFilters) {
      mapboxSearchData = JSON.parse(JSON.stringify(this.props.searchFilters))
    } else {
      //we have no payment data so we don't do anything.
      this.setState({
        searchLoading: false,
      })
      console.error(
        'The runSearch.js component needs search filter data either passed as a prop or through the processPayment main function.'
      )
      //console.log('The runSearch.js component needs search filter data either passed as a prop or through the processPayment main function.')
      return false
    }

    const apiURL = 'motorcycles/mapbox/search'
    let filtersData = removeDefaults(mapboxSearchData)
    let dataForAPI = formatForAPI(filtersData)

    apiProcess(apiURL, dataForAPI, 'mapbox-search', 'mapbox search call')
      .then(
        function (responseData) {
          this.setState({
            mapboxSearchError: false,
            mapboxSearchLoading: false,
            groupedMarkers: responseData.groupedMarkers,
            allCoordinates: responseData.allCoordinates,
            hasMapboxSearchData: responseData.groupedMarkers.length > 0,
          })
          this.props.onSuccess(responseData.results, responseData.results_meta)
        }.bind(this)
      )
      .catch(
        function (responseData) {
          this.setState({
            searchError: true,
            searchLoading: false,
            hasSearchData: false,
            searchData: [],
          })
        }.bind(this)
      )

    this.setState({ searchCount: this.state.searchCount + 1 })
  }

  runSearch = (passedInValues, searchCallDesc, filtersApplied, hasGooseEgg) => {
    if (this.state.searchLoading) {
      return
    }

    if (passedInValues) {
      if (passedInValues.latitude == null || passedInValues.longitude == null) {
        if (this.props.isGeolocationEnabled && this.state.searchCount === 0) {
          //if we are geo enabled we might be able to fix this in onupdate
          this.setState({ searchCount: this.state.searchCount + 1 })
          return false
        }
      }
    }

    let searchData = {}

    if (passedInValues) {
      searchData = JSON.parse(JSON.stringify(passedInValues))
    } else if (this.props.searchFilters) {
      searchData = JSON.parse(JSON.stringify(this.props.searchFilters))
    } else {
      //we have no payment data so we don't do anything.
      this.setState({
        searchLoading: false,
      })
      console.error(
        'The runSearch.js component needs search filter data either passed as a prop or through the processPayment main function.'
      )
      return false
    }

    const apiURL = 'motorcycles/search'
    let filtersData = removeDefaults(searchData)
    let dataForAPI = formatForAPI(filtersData)


    this.setState({
      searchLoading: hasGooseEgg ? false : true,
      searchError: false,
      initialLoading: false,
    })

    apiProcess(apiURL, dataForAPI, 'search', this.props.searchDescription)
      .then(
        function (responseData) {
          const prevResults = this.state.searchData.results || []
          // If filters are applied we need to clear prev data and show newly fetched filters results on search results page
          if (filtersApplied) {
            this.setState({
              searchError: false,
              searchLoading: false,
              searchData: responseData,
              hasSearchData: responseData?.results?.length > 0 ? true : false,
            })
          } else {
            // if not, persist previously fetched results and append them with currently fetched results.
            this.setState({
              searchError: false,
              searchLoading: false,
              searchData: {
                results: prevResults.concat(responseData.results),
                results_meta: responseData.results_meta
              },
              hasSearchData: responseData?.results?.length > 0 ? true : false,
            })
          }

          //change this when backend has a gooseEgg
          if (this.props.gooseEggSearch) {
            trackSearchAPIRan(
              'Search Goose Egg',
              filtersData,
              filtersData.location,
              responseData.results_meta
            )
          } else {
            trackSearchAPIRan(
              'Search',
              filtersData,
              filtersData.location,
              responseData.results_meta
            )
          }
          this.props.onSuccess(responseData.results, responseData.results_meta)
        }.bind(this)
      )
      .catch(
        function (responseData) {
          this.setState({
            searchError: true,
            searchLoading: false,
            hasSearchData: false,
            searchData: [],
          })
        }.bind(this)
      )

    this.setState({ searchCount: this.state.searchCount + 1 })
  }

  render() {
    const {
      searchLoading,
      searchError,
      hasSearchData,
      searchData,
      initialURLParams,
      initialLoading,
      mapboxSearchLoading,
      mapboxSearchError,
      hasMapboxSearchData,
      groupedMarkers,
      allCoordinates,
      advertisement,
    } = this.state
    const searchCallLoading = searchLoading || initialLoading ? true : false
    return (
      <React.Fragment>
        {' '}
        {this.props.render({
          searchLoading: searchCallLoading,
          runSearch: this.runSearch,
          runMapBoxSearch: this.runMapBoxSearch,
          searchError,
          hasSearchData,
          searchData,
          initialURLParams,
          mapboxSearchLoading,
          mapboxSearchError,
          hasMapboxSearchData,
          groupedMarkers,
          allCoordinates,
          advertisement,
          initialLoading
        })}{' '}
      </React.Fragment>
    )
  }
}

export default withRouter(CallSearch)

CallSearch.defaultProps = {
  searchFilters: null,
  searchDescription: 'Search Call',
  parseURLOnMount: true, //this only passes raw data, not formatted. Examples &brand=One,Two,Three is not brand : [One, Two, Three] but rather brand: 'one, two, three'
  updateOnLocationURLChange: true,
  updateURLOnLocationDiscovery: true,
  onSuccess: function () { },
  gooseEggSearch: false, // we can delete this later.
}
